import Body            from './Body'           ;
import Reject          from './Reject'         ;
import Create          from './Create'         ;
import Update          from './Update'         ;
import Filter          from './Filter'         ;
import Search          from './Search'         ;
import Approve         from './Approve'        ;
import Invoices        from './Invoice'        ;
import PayOffline      from './PayOfline'      ;
import ApproveDriver   from './ApproveDriver'  ;
import ShowInformation from './ShowInformation';

const Components = {
  Body           ,
  Reject         ,
  Create         ,
  Update         ,
  Filter         ,
  Search         ,
  Approve        ,
  Invoices       ,
  PayOffline     ,
  ApproveDriver  ,
  ShowInformation,
};

export default Components;
